module.exports = __webpack_public_path__ + "img/home-index-menu2.630da935.png";